"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localForage = void 0;
// @ts-ignore this explicit .js file has no typings
const localforage_js_1 = __importDefault(require("localforage/src/localforage.js"));
exports.localForage = localforage_js_1.default;
async function clearLocalForage() {
    await exports.localForage.clear();
    globalThis.location.reload();
}
// use this for debugging
globalThis.clearLocalForage = clearLocalForage;
globalThis.localForage = exports.localForage;
